export const fetchProducts = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    return fetch("/api/products/", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(products => {
            return dispatch({
              type: 'FETCH_PRODUCTS',
              products
            })
          })
        }  else {
          console.log("Server Error!");
          throw res.data
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/products.js